import React from 'react'
import { WkPanel, WKVisible } from '../../components/wk'
import ScheduleSigninItem from './ScheduleSigninItem'
import signinsEmptyImg from '../../images/schedule/signins-empty.png'


class ScheduleDetailSignins extends React.Component {
    render() {
        const { role, process } = this.props
        return (
            <WkPanel title={`全部动态${this.props.signinsCount ? `（${this.props.signinsCount}）` : ''}`} className='signins'>
                <div>
                    {/* 普通动态 */}
                    {
                        this.props.signins.map((item, i) => (
                            <ScheduleSigninItem
                                key={item.signin.id}
                                index={i}
                                account={item.signin.account}
                                signinInfo={item.signin}
                                images={item.signin.images}
                                onClickLike={e => this.props.onClickLike(item.signin.id, i)}
                                onClickComment={(commentId, commentIndex) => this.props.onClickComment(item.signin.id, commentId, i, commentIndex)}
                                isLike={item.liked}
                                likes={item.likes}
                                comments={item.comments}
                                onClickAudio={e => this.props.onClickAudio(i)}
                                audioCurrentTime={this.props.audioCurrentTime}
                                audioStatus={this.props.audioStatus}
                                selectedAudioIndex={this.props.selectedAudioIndex}
                                onClickDelSignin={(id, index) => this.props.onClickDelSignin(id, index)}
                                role={role}
                                isHot={item.isHot}
                            />
                        ))
                    }
                    <WKVisible create={process === 'not_start' && role.is_manager}>
                        <div className="empty">
                            <img src={signinsEmptyImg} alt=""/>
                            <div className="text">点击右上角分享邀请更多好友参与打卡</div>
                        </div>
                    </WKVisible>
                    <WKVisible create={process === 'not_start' && !role.is_manager}>
                        <div className="empty">
                            <img src={signinsEmptyImg} alt=""/>
                            <div className="text">点击下方参与打卡，记录动态</div>
                        </div>
                    </WKVisible>
                    <WKVisible create={process !== 'not_start' && this.props.signins.length === 0}>
                        <div className="empty">
                            <img src={signinsEmptyImg} alt=""/>
                            <div className="text">暂无动态</div>
                        </div>
                    </WKVisible>
                </div>
            </WkPanel>
        )
    }
}

export default ScheduleDetailSignins


// WEBPACK FOOTER //
// ./src/pages/schedule/ScheduleDetailSignins.js